import React, { useEffect } from 'react'
import { Switch, BrowserRouter, Route } from 'react-router-dom'
import { RouteConfig } from './route-config'
import { Route as CustomRoute } from './route'
import { withTransaction } from '@elastic/apm-rum-react'
import apm from '@Techedge/digitalportal-root'

const AppRouter = (props: any) => {
    const transaction = apm.startTransaction('DP-HomePageLoad', 'page-load', {
        managed: true,
    })

    const onPageLoaded = () => {
        if (transaction) {
            transaction?.end()
        }
    }

    useEffect(() => {
        onPageLoaded()
    }, [])

    return (
        <BrowserRouter basename="/">
            <Switch>
                {RouteConfig.map((route: CustomRoute, i: number) => {
                    const RouteComponent = route.component
                    console.log('route', route.props, route)
                    return (
                        <Route
                            key={i}
                            path={route.path}
                            exact={route.exact}
                            render={(props: any) => (
                                <RouteComponent {...route.props} {...props} />
                            )}
                        />
                    )
                })}
            </Switch>
        </BrowserRouter>
    )
}

export default withTransaction(
    'digitalportal-home',
    'digitalportal-mfe-load'
)(AppRouter)
